// Verbatim content — "The Composable Commerce Handbook: Snap. Swap. Scale."
// Source PDF text preserved; formatting normalised for web reading.

export default {
  lede:
    "Today's commerce landscape is undergoing a seismic shift. Customer expectations are rapidly evolving and the ever-changing tech landscape (AI, blockchain, Fintech, etc.) necessitates lightning-fast responses. Businesses must adapt to thrive.",
  chapters: [
    {
      title: 'Evolving Customer Demands: The New Frontier of Retail',
      sections: [
        {
          heading: null,
          body:
            'A composable commerce approach is a game-changer. With its modular approach, it empowers organisations to adapt with unprecedented speed and flexibility. This allows you to deploy new experiences, processes, products and solutions at a record pace — keeping your business nimble and competitive.'
        }
      ]
    },
    {
      title: 'What is Composable Commerce?',
      sections: [
        {
          heading: 'MACH-aligned by design',
          body:
            'Composable commerce transcends monolithic platforms, aligning seamlessly with the MACH Alliance principles: Microservices, API-first, Cloud-native and Headless. This empowers businesses to curate a best-of-breed commerce ecosystem — akin to building an ideal storefront out of interchangeable components — think a headless CMS for dynamic content management, or a cutting-edge payment gateway plugged in on its own terms.'
        },
        {
          heading: 'One ecosystem, many best-of-breed services',
          body:
            'Each independent service integrates seamlessly via APIs, fostering true customisation and adaptation. This modular approach unlocks a multitude of benefits: agility to respond swiftly to market shifts, scalability to effortlessly accommodate growth, and a future-proofed infrastructure ready for evolving customer demands and technological advancements.'
        }
      ]
    },
    {
      title: 'Business Advantages with Composable Commerce',
      sections: [
        {
          heading: 'Enhanced Agility',
          body:
            'The decoupled nature of composable commerce facilitates the rapid deployment of new features and functionalities. Businesses can leverage APIs to integrate best-of-breed solutions, accelerating time-to-market for innovation.'
        },
        {
          heading: 'Scalability on Demand',
          body:
            'Composable solutions scale horizontally, meaning businesses can add resources (e.g., servers) as needed to handle increased traffic or data volume. This eliminates the limitations of monolithic platforms.'
        },
        {
          heading: 'Optimised TCO',
          body:
            'Businesses can invest strategically in specific functionalities through independent solutions, reducing reliance on expensive, all-encompassing platforms. Additionally, API-driven integrations minimise vendor lock-in, allowing for cost-effective optimisation.'
        },
        {
          heading: 'Future-Proof Technology Stack',
          body:
            'Composable architecture embraces a technology-agnostic approach. Businesses can readily integrate emerging technologies (AI, AR/VR) through APIs, ensuring their commerce infrastructure remains adaptable to future needs.'
        },
        {
          heading: 'Omnichannel Orchestration',
          body:
            'Composable commerce facilitates the seamless integration of various customer touchpoints (website, mobile app, physical stores) through decoupled APIs. This empowers businesses to deliver a unified and personalised omnichannel customer experience.'
        }
      ]
    },
    {
      title: 'From Monolith to Composable',
      sections: [
        {
          heading: 'Start where the pace is felt',
          body:
            'The transition is a staged migration, not a re-platform. Start with the surface that changes fastest — typically content and merchandising — decouple it, run in parallel, then advance systematically through pricing, cart and checkout as confidence builds.'
        },
        {
          heading: 'The evolving digital commerce experience',
          body:
            'A modern commerce estate is not a single application; it is a set of best-of-breed services collaborating through API contracts. That means teams — content, commerce, merchandising, operations — can each work in the tool their craft actually needs, without waiting on the platform vendor to catch up.'
        }
      ]
    },
    {
      title: 'DigitalWorks Consulting Group: Building the Future of Commerce',
      sections: [
        {
          heading: 'Who We Are',
          body:
            'DigitalWorks is a forward-thinking technology consultancy dedicated to empowering businesses with the agility and innovation needed to thrive in the ever-evolving commerce landscape. We believe in the transformative power of composable commerce, and our team of experts is passionate about guiding businesses towards a future-proof commerce architecture.'
        },
        {
          heading: 'What We Do',
          body:
            'We partner with businesses of all sizes to unlock the full potential of composable commerce. Our services encompass a comprehensive range of solutions:\n\n> Composable Commerce Strategy: We help you define a clear vision for your composable commerce journey, ensuring your platform aligns with your unique business goals and customer needs.\n\n> Implementation Expertise: Our team possesses the technical prowess to seamlessly integrate best-of-breed solutions (CMS, payment gateways, etc.) into a cohesive and scalable commerce ecosystem.\n\n> Experience Design: We craft exceptional customer experiences across all touchpoints (website, mobile app, etc.) tailored to your brand identity and customer personas.\n\n> Data-Driven Optimisation: Leveraging the power of data, we optimise your commerce platform for performance — driving conversions and maximising customer lifetime value.'
        }
      ]
    }
  ],
  pullQuote:
    'Composable commerce facilitates the seamless integration of various customer touchpoints through decoupled APIs — that is what modern omnichannel actually looks like.',
  nwLink:
    'Composable commerce sets the ceiling; the operating model decides how close you get to it. Our approach combines the NeuralWorks framework with the delivery experience of teams who have done this on live estates.'
};
